import VKIcon from "assets/icons/VK";
import TelegramIcon from "assets/icons/Telegram";
import OKIcon from "assets/icons/OK";

export const contactDetails = [
  {
    description: 'Для звонков по Москве и Московской обл.',
    href: 'tel:+74955653010',
    text: '7 495 565 30 10',
    color: 'black.100',
  },
  {
    description: 'Для звонков по России',
    href: 'tel:88005698899',
    text: '8 800 569 88 99',
    color: 'black.100',
  },
  {
    description: 'Электронная почта',
    href: 'mailto:zabota@pervye.ru',
    text: 'zabota@pervye.ru',
    color: 'blue.100',
  },
];

export const documents = [
  {
    text: 'Политика конфиденциальности',
    href: 'https://files.pervye.ru/files/medialibrary/%D0%9F%D0%BE%D0%BB%D0%B8%D1%82%D0%B8%D0%BA%D0%B0_%D0%A0%D0%94%D0%94%D0%9C-2.pdf', // Замените на реальный путь
  },
  {
    text: 'Пользовательское соглашение',
    href: 'https://s3.будьвдвижении.рф/vk_backup/iblock/d77/tn3nfdgxtaib8ss4s3rawc58saetim2r.pdf', // Замените на реальный путь
  },
];

export const SOCIAL_MEDIAS = [
  {
    icon: VKIcon,
    href: 'https://vk.com/mypervie'
  },
  {
    icon: TelegramIcon,
    href: 'https://t.me/mypervie'
  },
  {
    icon: OKIcon,
    href: 'https://ok.ru/mypervie'
  },
]

export const FOOTER_DATA = {
  inn: "ИНН/КПП 9709087880/770901001",
  copyright: "© 2026 Движение первых"
}
